<template>
  <div class="bg-white border-round mapToolbox p-buttonset p-buttonset-vertical" style="width: 30px">
    <MapButton label="Reset bearing" size="small" icon="/icons/toolbox/north.svg" @action="resetBearing"
               :icon-style="bearingIconStyle"/>
    <MapButton label="Reset pitch" size="small" icon="/icons/toolbox/viewpoint.svg"
               :icon-style="pitchIconStyle" @action="resetPitch"/>
  </div>
</template>
<script lang="ts">

import {defineComponent, PropType} from "vue";
import Button from "primevue/button";
import {MapController} from "../../../js/Map/map-controller";
import MapButton from "../MapButton.vue";

export default defineComponent({
  name: 'MapOrientationControl',
  components: {MapButton, Button},
  props: {
    mapController: {
      type: Object as PropType<MapController>,
      required: true,
    },
  },
  mounted() {
    this.updateView();
    this.mapController.mapInstance.on('rotate', this.updateView);
    this.mapController.mapInstance.on('pitch', this.updateView);
  },
  computed: {
    bearingIconStyle() {
      let bearing = 0 - this.bearing;
      return {
        transform: `rotate(${bearing}deg)`
      }
    },
    pitchIconStyle() {
      let pitch = 90 - this.pitch;
      return {
        transform: `rotate(${pitch}deg)`
      }
    },
  },
  methods: {
    updateView() {
      this.bearing = this.mapController.mapInstance.getBearing();
      this.pitch = this.mapController.mapInstance.getPitch();
      this.$forceUpdate();
    },
    resetBearing() {
      this.mapController.mapInstance.flyTo({bearing: 0, maxDuration: 300})
    },
    resetPitch() {
      this.mapController.mapInstance.flyTo({pitch: 0, maxDuration: 300})
    }
  },
  data() {
    return {
      bearing: 0,
      pitch: 0
    }
  },

})
</script>
